export default __webpack_public_path__ + "static/nrc-media-6d72d855aef9bbd551ffff7c99fe51db.webp";